import { CardTitle } from "@/shared/components/common/Card";
import Typography from "@/shared/components/common/Typography";

interface RoomCardTitleProps {
  name: string;
  ratePlan: string;
}

export default function RoomCardTitle({ name, ratePlan }: RoomCardTitleProps) {
  return (
    <CardTitle className="flex flex-row items-center gap-2">
      <Typography variant={"h3"}>{name}</Typography>
      <Typography
        variant={"body3"}
        className="text-muted-foreground dark:text-muted"
      >
        ({ratePlan})
      </Typography>
    </CardTitle>
  );
}
